import { ADD_ALERT, REMOVE_ALERT, CLEAR_ALERTS } from './action-types';
import _ from 'lodash';

export default function alerts(state = { nextId: 0, alerts: [] }, action) {
  const newState = _.assign({}, state);

  switch (action.type) {
    case ADD_ALERT:  // eslint-disable-line no-case-declarations
      const alertWithSameSubtitleAlreadyExists = _.find(newState.alerts, { subtitle: action.alert.subtitle });
      if (action.alert.type === 'danger' && alertWithSameSubtitleAlreadyExists) break;

      newState.alerts = [
        ...newState.alerts,
        action.alert
      ];
      newState.nextId++;
      break;
    case REMOVE_ALERT: // eslint-disable-line no-case-declarations
      const removedAlert = _.find(newState.alerts, { id: action.alertId }) || {};
      window.clearTimeout(removedAlert.timeout); // If there's a timeout waiting to clear the alert, cancel it now
      newState.alerts = _.reject(newState.alerts, { id: action.alertId });
      break;
    case CLEAR_ALERTS:
      newState.alerts = [];
      break;
    default:
      return state;
  }

  return newState;
}



// WEBPACK FOOTER //
// ./app/modules/alerts/reducers.js